import { forwardRef, type ReactNode } from "react";

import { WifiOutline24Icon } from "@vygruppen/spor-icon-react";
import type { ButtonProps } from "@vygruppen/spor-react";
import { Button } from "@vygruppen/spor-react";

import { useNetworkConnectivity } from "~/features/network-connectivity/use-network-connectivity";
import { useHydrated } from "~/hooks/use-hydrated";

export const NetworkDependentButton = forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, "as">
>(function NetworkDependentButton({ onClick, ...props }, ref): ReactNode {
  const isHydrated = useHydrated();

  const { isOnline } = useNetworkConnectivity();

  const isNotHydratedOrOnline = !isOnline || !isHydrated;

  return (
    <Button
      ref={ref}
      {...(!isNotHydratedOrOnline && { onClick })}
      {...props}
      leftIcon={isNotHydratedOrOnline ? <WifiOutline24Icon /> : props.leftIcon}
      disabled={isNotHydratedOrOnline || props.disabled}
      title={
        isNotHydratedOrOnline ? "Kan ikke utføres uten nett." : props.title
      }
    />
  );
});
